export const configEduForms = {
    1: 'Очная',
    2: 'Очно-заочная',
    3: 'Заочная',
};

export const configEduFormsTranslateMap = {
    1: 'edu_forms.full_time',
    2: 'edu_forms.part_time',
    3: 'edu_forms.correspondence',
};